import {getDocumentsByOpsOrderId} from 'actions/documentsActions'
import {LOADED, LOADING, UNSET} from 'constants/reduxStatuses'
import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {documentsSelector, documentsStatusSelector} from 'selectors/documentsSelectors'
import {useAppDispatch} from 'services/store'

export type DownloadDocumentMap = {
  APPRAISAL: {documentId: string; fileName: string}
  DELIVERABLE_PDF: {documentId: string; fileName: string}
  INVOICE: {documentId: string; fileName: string}
}

export const useDownloadDocumentsMap = (opsOrderId: string) => {
  const [error, setError] = useState('')
  const [data, setData] = useState<DownloadDocumentMap>()
  const status = useSelector(documentsStatusSelector)
  const loading = status === LOADING
  const documentsStoreData = useSelector(documentsSelector)
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (status === LOADED) {
      try {
        const downloadDocumentMap = {} as DownloadDocumentMap
        const filteredAppraisals = documentsStoreData.filter(
          ({documentType}) => documentType === 'APPRAISAL_PDF' || documentType === 'APPRAISAL_MISMO'
        )
        const sortedAppraisals = filteredAppraisals.sort((a, b) => {
          const bUploadDate = b?.uploadDate && new Date(b?.uploadDate).valueOf()
          const aUploadDate = a?.uploadDate && new Date(a?.uploadDate).valueOf()
          if (bUploadDate && aUploadDate) return bUploadDate - aUploadDate
          else return 0
        })
        const appraisalDocumentId = sortedAppraisals[0].documentId
        const appraisalFileName = sortedAppraisals[0].fileName
        if (appraisalDocumentId && appraisalFileName) {
          downloadDocumentMap.APPRAISAL = {
            documentId: appraisalDocumentId,
            fileName: appraisalFileName
          }
        }
        const deliverablePdf = documentsStoreData.find(
          ({documentType}) => documentType === 'DELIVERABLE_PDF'
        )
        if (deliverablePdf?.documentId && deliverablePdf?.fileName)
          downloadDocumentMap.DELIVERABLE_PDF = {
            documentId: deliverablePdf?.documentId,
            fileName: deliverablePdf?.fileName
          }

        setData(downloadDocumentMap)
      } catch (e) {
        setError('get documents failed')
      }
    }
  }, [documentsStoreData, status])

  useEffect(() => {
    const fetchDocuments = async () => {
      if (status === UNSET) {
        dispatch(await getDocumentsByOpsOrderId(opsOrderId))
      }
    }
    fetchDocuments()
  }, [dispatch, opsOrderId, status])

  return {data, error, loading}
}
